export default __webpack_public_path__ + "static/media/solution_74.15c4c916.svg";